import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { MyProfileService } from '@services/my-profile/my-profile.service';
import { FormDirective } from '../../directives/form/form.directive';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { DefaultFormComponent } from '../../components/default-form/default-form.component';
import { FormComponent } from '../../components/default-form/form.component';
import { MessengerService } from '@services/messenger/messenger.service';
import { PrivilegeGuard } from '../../guards/privilege.guard';

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss'],
    providers: [MyProfileService],
    standalone: false
})
export class MyProfileComponent implements OnInit {

  @ViewChild(FormDirective) formHost: FormDirective;

  pageActions: PageAction[];
  isLoading = true;
  boundProfile: Models.Profile;
  changePassword = false;
  changeEmail = false;
  passwordNew: string;
  password: string;
  emailNew: string;
  email: string;
  isReadOnly = false;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private profileService: MyProfileService,
    private activatedRoute: ActivatedRoute,
    private snackbar: SnackbarService,
    private ms: MessengerService,
    private priv: PrivilegeGuard,
  ) {
  }

  ngOnInit() {
    this.initProfile();
  }

  initProfile() {
    this.isLoading = true;
    this.changePassword = false;
    this.changeEmail = false;
    this.passwordNew = null;
    this.password = null;
    this.emailNew = null;
    this.profileService.find(0, 1).then(result => {
      if (!result || !result.data || result.data.length !== 1) {
        return;
      }
      this.boundProfile = result.data[0];
      if (this.boundProfile && this.boundProfile.email) {
        this.email = this.boundProfile.email;
      }
      this.isReadOnly = this.priv.checkIfPrivilege('noWrite', 'my-profile');
      this.isLoading = false;
      this.loadForm();
    });
  }

  loadForm() {
    const formItem = DefaultFormComponent;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);

    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.boundProfile;
  }

  onPasswordValidatiton(password) {
    if (password) {
      this.passwordNew = password;
    }
  }

  validateEmail() {
    return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.emailNew);
  }

  onSave() {
    if (this.changePassword && this.passwordNew || this.changeEmail) {
      this.saveCredentials().then(result => {
        if (!result) {
          return false;
        }
        this.boundProfile.email = result.email;
        this.saveProfile();
      })
    } else {
      this.saveProfile();
    }

  }

  saveCredentials(): Promise<any> {
    return new Promise((resolve) => {
      const data = {
        loginName: this.email,
        loginNameNew: this.changeEmail && this.emailNew ? this.emailNew : null,
        passwordOld: this.password,
        passwordNew: this.changePassword && this.passwordNew ? this.passwordNew : null,
      };
      // ask for user name and password
      this.ms.updateCredentials(this.boundProfile.ProfileID, data).then(result => {
        this.snackbar.success('New credentials are saved');
        resolve(result);
      }, err => {
        const message = err.message || err;
        this.snackbar.error('Error on saving new credentials: ' + message);
        resolve(false);
      });
    });
  }

  saveProfile() {
    return this.boundProfile.validate(true).then(result => {
      if (result.success) {
        this.profileService.update(this.boundProfile.ProfileID, this.boundProfile, { query: { updateSettings: true } }).then(profileResult => {
          this.snackbar.success('Your profile has been successfully updated');
          this.initProfile();
        });
      } else {
        this.snackbar.open('Could not change the profile, please fill in the form correctly');
      }
    });
  }
}
